import React from 'react'

import { isWebpSupported } from 'helpers'

import { SiteContext } from 'context/site-context'

import './index.scss'

const Discover = () => {
  const [ site ] = React.useContext(SiteContext)

  return <React.Fragment>
    {site.discover ? <div className="discover-container">
      {site.topBusinesses[site.upsellCategory]?.results?.locations?.length > 0 ? <React.Fragment>
        <h2>Discover <span className="highlight">{site.discover[site.upsellCategory].label}</span> {site.location && `in ${site.location}`}</h2>
        <img src={isWebpSupported() && site.discover[site.upsellCategory].imageWebP ? site.discover[site.upsellCategory].imageWebP : site.discover[site.upsellCategory].image} alt="Discover" />
      </React.Fragment> : <React.Fragment>
        <h2>Discover <span className="highlight">CitySearch</span></h2>
        <div className="city-thumbs-container">
          <p>Founded in 1995, CitySearch has focused on local businesses and community and, most importantly, bringing the two together.</p>
          {
            //site.hero?.city_images?.map( image => <img src={isWebpSupported() && image.imageWebP ? image.imageWebP : image.image} key={image.image} />)
          }
        </div>
      </React.Fragment>}
    </div> : null}
  </React.Fragment>
}

export default Discover
